var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topnavbar'),_c('navigation'),_c('div',{staticClass:"gray-bg",staticStyle:{"margin-top":"60px"},attrs:{"id":"page-wrapper"}},[_c('div',[_c('breadcrumb')],1),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }